import {Utilities} from '../utilities/utilities.model';
import { NemoModuleKeys } from './user-permission.model';

export class ItemMenu {
	id: string;
	name: string;
	routerLink: string;
	icon: string;
	isPrimary: boolean;
	count: number;
	module_key?: NemoModuleKeys;
	profile_key?: string;
	profile_name?: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.name = model.name;
			this.routerLink = model.routerLink;
			this.icon = model.icon;
			this.isPrimary = model.isPrimary;
			this.count = model.count;
			this.module_key = model.module_key ? model.module_key : null;
			this.profile_key = model.profile_key ? model.profile_key : null;
			this.profile_name = model.profile_name ? model.profile_name : null; 
		}
	}
}
